// Выбор диапазона в фильтре

import {Component, h} from 'preact';
import {MultiSlider} from 'preact-range-slider';

/**
 * Component Properties
 */
interface FilterRangeProps
{
	/** Имя формы */
	formName: string;
	/** Подпись группы */
	label: string;
	/** Имя поля */
	name: string;
	/** Минимальное значение */
	min: number;
	/** Максимальное значение */
	max: number;
	/** Текущее начальное значение */
	from: number;
	/** Текущее конечное значение */
	to: number;
	/** Шаг изменения */
	step: number;
}

/**
 * Component State
 */
interface FilterRangeState
{
	/** Текущее локальное начальное значение */
	from: number;
	/** Текущее локальное конечное значение */
	to: number;
}

/**
 * Выбор диапазона в фильтре
 */
class FilterRange extends Component<FilterRangeProps, FilterRangeState>
{
	/**
	 * Элемент поля начального значения
	 */
	private inputFrom: HTMLInputElement;
	/**
	 * Элемент поля конечного значения
	 */
	private inputTo: HTMLInputElement;
	/**
	 * В процессе изменения значения?
	 */
	private changing: boolean = false;
	
	private static formatValue( value: number ): string
	{
		return String( value ).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ' );
	}
	
	/**
	 * Выбор диапазона в фильтре
	 */
	public constructor( props: FilterRangeProps )
	{
		super( props );
		
		this.state = {
			from: props.from,
			to: props.to,
		};
	}
	
	/**
	 * Before render, return false to skip render
	 */
	public shouldComponentUpdate(
		props: FilterRangeProps,
		state: FilterRangeState,
	): boolean
	{
		return (
			(
				this.changing
				&& (
					( this.state.from !== state.from )
					|| ( this.state.to !== state.to )
				)
			)
			|| ( this.props.from !== props.from )
			|| ( this.props.to !== props.to )
			|| ( this.props.min !== props.min )
			|| ( this.props.max !== props.max )
			|| ( this.props.step !== props.step )
			|| ( this.props.name !== props.name )
			|| ( this.props.label !== props.label )
			|| ( this.props.formName !== props.formName )
		);
	}
	
	/**
	 * Render component
	 */
	public render(
		{formName, label, name, min, max, from, to, step}: FilterRangeProps,
		state: FilterRangeState,
	): JSX.Element
	{
		const nameFrom = name + 'From';
		const nameTo = name + 'To';
		const idFrom = `f-${formName}-${nameFrom}`;
		const idTo = `f-${formName}-${nameTo}`;
		
		if ( this.changing )
		{
			from = state.from;
			to = state.to;
		}
		
		return (
			<li class={'range field-' + name}>
				<fieldset>
					<legend>{label}</legend>
					<span class="from">
						<label for={idFrom} data-value={FilterRange.formatValue( from )}>от</label>
						<input
							type="text"
							name={nameFrom}
							id={idFrom}
							min={min}
							max={max}
							step={step}
							value={String( from )}
							ref={this.refInputFrom}
							onFocus={this.onInputFocus}
							onBlur={this.onInputBlur}
						/>
					</span>
					<span class="to">
						<label for={idTo} data-value={FilterRange.formatValue( to )}>до</label>
						<input
							type="text"
							name={nameTo}
							id={idTo}
							min={min}
							max={max}
							step={step}
							value={String( to )}
							ref={this.refInputTo}
							onFocus={this.onInputFocus}
							onBlur={this.onInputBlur}
						/>
					</span>
					<MultiSlider
						min={min}
						max={max}
						step={step}
						value={[from, to]}
						tipFormatter={FilterRange.formatValue}
						onBeforeChange={this.onRangeBeforeChange}
						onChange={this.onRangeChange}
						onAfterChange={this.onRangeAfterChange}
					/>
				</fieldset>
			</li>
		);
	}
	
	private refInputFrom = ( element: HTMLInputElement ): void =>
	{
		this.inputFrom = element;
	}
	
	private refInputTo = ( element: HTMLInputElement ): void =>
	{
		this.inputTo = element;
	}
	
	private onInputFocus = ( event: Event ): void =>
	{
		const target = event.target as HTMLInputElement;
		const parent = target.parentElement;
		
		if ( parent )
		{
			parent.classList.add( 'focus' );
		}
	}
	
	private onInputBlur = ( event: Event ): void =>
	{
		const target = event.target as HTMLInputElement;
		const parent = target.parentElement;
		
		if ( parent )
		{
			parent.classList.remove( 'focus' );
		}
	}
	
	private onRangeBeforeChange = ( value: number[] ): void =>
	{
		this.setState(
			{
				from: value[0],
				to: value[1],
			},
		);
		
		this.changing = true;
	}
	
	private onRangeChange = ( value: number[] ): void =>
	{
		this.setState(
			{
				from: value[0],
				to: value[1],
			},
		);
	}
	
	private onRangeAfterChange = ( value: number[] ): void =>
	{
		const fractionDigits = String( this.props.step )
			.replace( /^[^.]+\.?/, '' ).length;
		
		this.inputFrom.value = value[0].toFixed( fractionDigits );
		this.inputTo.value = value[1].toFixed( fractionDigits );
		
		this.inputFrom.dispatchEvent(
			new CustomEvent(
				'change',
				{
					bubbles: true,
				},
			),
		);
		this.inputTo.dispatchEvent(
			new CustomEvent(
				'change',
				{
					bubbles: true,
				},
			),
		);
		
		this.changing = false;
	}
	
}

/**
 * Module
 */
export {
	FilterRange as default,
	FilterRangeProps,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/FilterRange.tsx